import KendoMenu from '../KendoMenu'
import KendoMenuItem from '../KendoMenu/KendoMenuItem'
import KendoContextMenu from '../KendoContextMenu'
import KendoPanelBar from '../KendoPanelBar'
import KendoPanelBarItem from '../KendoPanelBar/KendoPanelBarItem'
import KendoTabStrip from '../KendoTabStrip'
import KendoSplitter from '../KendoSplitter'
import KendoSplitterPane from '../KendoSplitter/KendoSplitterPane'

let KendoLayoutInstaller = class {
    static install(Vue) {
        Vue.component(KendoMenu.name, KendoMenu)
        Vue.component(KendoContextMenu.name, KendoContextMenu)
        Vue.component(KendoMenuItem.name, KendoMenuItem)
        Vue.component(KendoPanelBar.name, KendoPanelBar)
        Vue.component(KendoPanelBarItem.name, KendoPanelBarItem)
        Vue.component(KendoTabStrip.name, KendoTabStrip)
        Vue.component(KendoSplitter.name, KendoSplitter)
        Vue.component(KendoSplitterPane.name, KendoSplitterPane)
    }
}

export default KendoLayoutInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(KendoLayoutInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/kendo-layout-installer/index.js